import styled from 'styled-components';
import { BlankUserIcon } from 'src/components/common/icon';

export const Avatar = styled.img`
	border-radius: 50px;
	width: ${props => (props.isReplier ? '40px' : '60px')};
	height: ${props => (props.isReplier ? '40px' : '60px')};
	margin-right: 12px;

	@media ${props => props.theme.device.mobile} {
		width: 40px;
		height: 40px;
		margin-right: 8px;
	}
`;

export const BlankAvatar = styled(BlankUserIcon)`
	border-radius: 50px;
	margin-right: 12px;

	@media ${props => props.theme.device.mobile} {
		width: 40px;
		height: 40px;
		margin-right: 8px;
	}
`;
